var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.789 9.596V7.981H11.21v1.615h1.578Zm0 6.423V11.21H11.21v4.808h1.578Zm-6.46-9.653C7.906 4.79 9.797 4 12 4c2.203 0 4.081.789 5.634 2.366C19.21 7.92 20 9.796 20 12c0 2.203-.789 4.094-2.366 5.671C16.08 19.224 14.204 20 12 20c-2.203 0-4.094-.776-5.671-2.329C4.776 16.094 4 14.203 4 12c0-2.203.776-4.081 2.329-5.634Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgInfo);
export default Memo;